const AMOUNTS = [10, 50, 100, 500, 1000];

const Recharge = () => (
  <>
    <p className="console-panel-desc">为账户充值，支持微信、支付宝等方式。</p>
    <div className="console-stats" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
      {AMOUNTS.map((amount) => (
        <button
          key={amount}
          type="button"
          className="console-stat-card"
          style={{ cursor: 'pointer', textAlign: 'center', border: '1px solid var(--border)' }}
        >
          <div className="console-stat-value" style={{ fontSize: '1.25rem' }}>
            ¥{amount}
          </div>
        </button>
      ))}
    </div>
    <div className="console-card" style={{ maxWidth: '28rem' }}>
      <div className="console-card-header">
        <h3 className="console-card-title">自定义金额</h3>
      </div>
      <div className="console-card-body">
        <label className="console-label">充值金额（CNY）</label>
        <input className="console-input" type="number" placeholder="请输入金额" min="1" />
        <div style={{ marginTop: '1rem', display: 'flex', gap: '0.75rem' }}>
          <button type="button" className="console-btn">
            微信支付
          </button>
          <button type="button" className="console-btn console-btn-outline">
            支付宝
          </button>
        </div>
      </div>
    </div>
  </>
);

export default Recharge;
